import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import filterAction from '../../actions/filterAction';

const SallSpecies = () => {
  const location = useLocation();
  const setApp = useDispatch();
  const { sbBlock } = useSelector(s => s.sb);
  const { allMarkers } = useSelector(s => s.markers);
  const { speciesStudyList } = useSelector(s => s.species);
  const [list, setList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [filterSearch, setFilterSearch] = useState('');

  const { pathname } = location;

  useEffect(() => {
    if (pathname === '/species') {
      batch(() => {
        setApp({ type: '_SIDEBAR', payload: ['sbBlock', 'Species'] });
        setApp({ type: '_FILTERED', payload: ['label', null] });
        setApp({ type: '_STUDY_DETAIL', payload: ['studyTitle', null] });
        setApp({ type: '_STUDY_DETAIL', payload: ['studyID', []] });
        setApp({ type: '_MARKERS_INIT' });
      });
    }
  }, [pathname, allMarkers]);

  useEffect(() => {
    if (
      (sbBlock === 'Species') &&
      (!list.length && speciesStudyList)
    ) {
      setDataList(speciesStudyList);
      setList(speciesStudyList);
    }
  }, [sbBlock, speciesStudyList]);

  if (sbBlock !== 'Species') {
    return null;
  }

  return (
    <>
      {
        sbBlock !== 'Species' ? null : (
          <div className="sb-body-inner">
            <h6 className="sb-filter-text">
              <i className="fa fa-list" /> SPECIES
            </h6>

            <div className="sb-tab-list">
              {
                !list.length
                  ? null
                  : (
                      <span id="sb-total-projects">
                        Total: <b>{list.length}</b> Species
                      </span>
                    )
              }
            </div>

            <div className="sb-project-list">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fa fa-search" />
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  value={filterSearch}
                  placeholder="Type to filter species list below..."
                  aria-label="Type to filter species list below..."
                  onChange={(event)=>{
                    setFilterSearch(event.target.value);
                    const regex = new RegExp(
                      `^.*${
                        event.target.value
                          .trim()
                          .replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
                      }.*$`, `i`
                    );

                    const s = event.target.value.trim()
                      ? list.filter(v => regex.test(v.scientificName))
                      : list;
                    setDataList(s);
                  }}
                />
              </div>
              {list.length === 0 && <div className="lds-dual-ring2"/>}
              {
                dataList.length > 0 && (
                  <>
                    <ul className="list-unstyled">
                    {
                      dataList.map((d)=>{

                        return (
                          <li role="presentation" key={d.scientificName}
                            onClick={()=>{
                              setApp(filterAction({
                                allMarkers,
                                sid:d.studyId,
                                label:`Species (<b>${d.scientificName}</b>)`,
                                filterSlug: d.scientificNameSlug
                              }));
                          }}>
                            <Link to={`/species/${d.scientificNameSlug}`}>
                              {d.scientificName}
                            </Link>
                          </li>
                        )

                      })
                    }
                    </ul>
                  </>
                )
              }
            </div>
          </div>
        )
      }
    </>
  );
};

export default SallSpecies;
